export default __webpack_public_path__ + "static/media/pinterest_m.86663318.svg";